import { createFileRoute } from '@tanstack/react-router'

import { AdminOrdersPage } from '@/pages/admin/orders/admin-orders-page'
import { DEFAULT_ORDERS_SEARCH, ordersSearchSchema } from '@/utils/orders-search-params'

export const Route = createFileRoute('/_private/admin/orders')({
  component: AdminOrdersPage,
  // Single source of truth for filters / page lives in the URL. `.catch()`
  // short-circuits to the default view on a malformed link so the page paints
  // instead of the router throwing on a bad query string.
  validateSearch: (search) => ordersSearchSchema.catch(DEFAULT_ORDERS_SEARCH).parse(search),
})
